import React from 'react';
export function AnnouncementBar() {
  return <div className="ann fixed top-0 left-0 right-0 z-[100] px-4 py-[9px] text-center backdrop-blur-md border-b border-[rgba(232,150,12,0.3)] bg-[linear-gradient(90deg,rgba(26,22,40,0.95),rgba(34,30,50,0.98)_50%,rgba(26,22,40,0.95))]" data-id="element-20">
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-[linear-gradient(90deg,transparent,rgba(245,192,48,0.9)_30%,#fde68a_50%,rgba(245,192,48,0.9)_70%,transparent)] bg-[length:200%_auto] animate-[shimmer_3s_linear_infinite]" data-id="element-21" />
      <p className="text-[12px] tracking-[0.05em] flex items-center justify-center gap-2.5 flex-wrap text-[var(--text)] m-0" data-id="element-22">
        <span className="iri font-semibold" data-id="element-23">
          +342 personas ya cerraron lo que no podían soltar
        </span>
        <span className="text-[rgba(232,150,12,0.35)]" data-id="element-24">·</span>
        <span className="inline-flex gap-[2px]" data-id="element-25">
          {[...Array(5)].map((_, i) => <svg key={i} className="w-[11px] h-[11px] fill-[var(--gold)] text-[var(--gold)] drop-shadow-[0_0_4px_rgba(232,150,12,0.9)]" viewBox="0 0 24 24" data-id="element-26">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-27" />
            </svg>)}
        </span>
        <span className="iri font-bold" data-id="element-28">4.9/5</span>
      </p>
    </div>;
}